import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const waitlistApi = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

export const submitWaitlist = (data) =>
  waitlistApi.post('/waitlist/signup/', data);
